<template>
    <div class="toolbox-pane">
        <div class="head">
            <div class="title">
                <img :src="`/images/icons/${icon}.svg`" alt="">
                {{ name }}
            </div>
            <div class="actions">
                <slot name="actions">
                    <a v-if="collapsible"
                       href="#"
                       class="btn btn-sm btn-link"
                       @click.prevent="toolbox_collapse_set(true)">
                        <img src="/images/icons/minimize.svg" alt="">
                    </a>
                </slot>
            </div>

            <div class="head-actions">
                <slot name="head-actions"></slot>
            </div>

        </div>
        <div class="toolbox-content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import {mapMutations} from "vuex";

export default {
    name: "ToolboxPane",
    props: {
        name: {
            type: String,
            default: 'Toolbox',
        },
        icon: {
            type: String,
            default: 'toolbox',
        },
        collapsible: {
            type: Boolean,
            default: true,
        }
    },


    computed: {
    },

    methods: {
        ...mapMutations(['toolbox_collapse_set']),
    }

}
</script>

<style lang="scss" scoped>
.toolbox-pane{
    background: lighten($light, 1%);
    box-shadow: rgba(200,200,200,0.1) 2px 0 3px;
    height: 100%;
    border-radius: 0 6px 6px 0;
    border: 0.5px solid #E2E2E2;
    border-left: none;
    display: flex;
    flex-direction: column;
}

.head{
    display: flex;
    align-items: center;
    padding: 0.5rem 1rem;
    min-height: 44px;

    .title{
        margin-right: auto;
        display: flex;
        align-items: center;
        font-weight: $font-weight-semibold;
        text-transform: uppercase;
        line-height: 1;

        img{
            margin-right: 0.4rem;
        }
    }

    .actions{
        margin-left: auto;
    }
}

.toolbox-content{
    overflow: auto;
    padding: 1rem 0;
}
</style>
